import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

const DMP_API_EVENTS_URL_REGEXP = /^https:\/\/.*\.member\.(placewise\.com|dev\.placewise\.com)\/api\/v2\/.*\/(events)$/;
if (environment.sentryDSN) {
  Sentry.init({
    dsn: environment.sentryDSN,
    release: environment.commitId,
    environment: environment.sentryEnvironment,
    integrations: [
      //https://placewisegroup.slack.com/archives/C013HJCGZ33/p1745389780942909?thread_ts=1744950589.907239&cid=C013HJCGZ33
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [422],
        failedRequestTargets: [DMP_API_EVENTS_URL_REGEXP],
      }),
    ],
    sendDefaultPii: true,
  });
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = (): Promise<NgModuleRef<AppModule>> => platformBrowserDynamic().bootstrapModule(AppModule);

bootstrap().catch(err => console.log(err));
